import { render } from "./GuestList.vue?vue&type=template&id=4fc63638&scoped=true&ts=true"
import script from "./GuestList.vue?vue&type=script&lang=ts"
export * from "./GuestList.vue?vue&type=script&lang=ts"

import "./GuestList.vue?vue&type=style&index=0&id=4fc63638&scoped=true&lang=css"

import exportComponent from "/var/www/mmwapp/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc63638"]])

export default __exports__